module.exports = __webpack_public_path__ + "static/media/loading-buffering.f4404720.gif";